import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1d98b5c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "page-header-box"
};
const _hoisted_2 = {
    key: 0,
    class: "page-header"
};
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        path: { default: "" }
    },
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const meta = computed(() => route.meta);
        const goBack = () => {
            if (meta.value.backPath) {
                router.push(meta.value.backPath);
            }
            else {
                router.go(-1);
            }
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (!_unref(meta).hiddenHeader)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (!_unref(meta).hiddenHeader)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_unref(meta).back)
                                ? (_openBlock(), _createBlock(_component_svg_icon, {
                                    key: 0,
                                    "icon-class": "back-bg",
                                    "class-name": "back-icon",
                                    onClick: goBack
                                }))
                                : _createCommentVNode("", true),
                            _renderSlot(_ctx.$slots, "header", {}, () => [
                                _createTextVNode(_toDisplayString(_unref(meta).title), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
